module.exports = __webpack_public_path__ + "static/media/9.33b98dfb.png";